import { component } from "picoapp";

export const zestButton = component((node) => {
  const trigger = node.querySelector<HTMLElement>("[data-zest-trigger] button");
  if (!trigger) return;

  const triggerZestModal = () => {
    const zestElement = node.querySelector<HTMLElement>("zest-button button");
    if (zestElement) {
      zestElement.click();
    }
  };

  trigger.addEventListener("click", triggerZestModal);

  return () => {
    if (trigger) {
      trigger.removeEventListener("click", triggerZestModal);
    }
  };
});
